import { FlaskConical } from 'lucide-react';

// Staging is detected by hostname so no per-env build config is needed;
// VITE_APP_ENV=staging forces it for any future custom domain.
export function isStagingEnvironment(): boolean {
  if (import.meta.env.VITE_APP_ENV === 'staging') return true;
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host.includes('staging') || host === 'localhost';
}

export function EnvironmentBanner() {
  if (!isStagingEnvironment()) return null;

  return (
    <div className="sticky top-0 z-[200] bg-emerald-600 text-white text-center text-xs sm:text-sm font-semibold py-1.5 px-3 flex items-center justify-center gap-1.5 shadow-md">
      <FlaskConical className="w-4 h-4 shrink-0" />
      TEST ENVIRONMENT — staging data only, not the live system
    </div>
  );
}
